import { render, staticRenderFns } from "./ParametroSistemaView.vue?vue&type=template&id=896eed86&"
import script from "./ParametroSistemaView.vue?vue&type=script&lang=js&"
export * from "./ParametroSistemaView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports